/* eslint-disable @typescript-eslint/naming-convention */

import {PlayerColor} from '@colonist/game-states'
import {type ImageURL} from '@colonist/types'
import ColonistRushBackgroundGradient from '@static/images/colonist_rush_background_gradient.png'
import {Sprites as SpritesImported} from './UIGameSprites.ts'

import Dice1 from '@static/images/dice_1.svg'
import Dice2 from '@static/images/dice_2.svg'
import Dice3 from '@static/images/dice_3.svg'
import Dice4 from '@static/images/dice_4.svg'
import Dice5 from '@static/images/dice_5.svg'
import Dice6 from '@static/images/dice_6.svg'
import DiceRed1 from '@static/images/dice_red_1.svg'
import DiceRed2 from '@static/images/dice_red_2.svg'
import DiceRed3 from '@static/images/dice_red_3.svg'
import DiceRed4 from '@static/images/dice_red_4.svg'
import DiceRed5 from '@static/images/dice_red_5.svg'
import DiceRed6 from '@static/images/dice_red_6.svg'
import DiceEventBarbarian from '@static/images/dice_event_barbarian.svg'
import DiceEventScience from '@static/images/dice_event_science.svg'
import DiceEventTrade from '@static/images/dice_event_trade.svg'
import DiceEventPolitics from '@static/images/dice_event_politics.svg'

enum Tag {
    // Images for Preloading
    Universal,
    SpriteSheet,
    Sprite,
}

export interface ImageInterface {
    name: string
    path: ImageURL
    tags: Tag[]
}

export import Sprites = SpritesImported

const allImages: ImageInterface[] = [
    {name: 'game_spritesheet_0', path: new URL('@static/images/game_spritesheet_0.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    {name: 'game_spritesheet_1', path: new URL('@static/images/game_spritesheet_1.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    {name: 'game_spritesheet_2', path: new URL('@static/images/game_spritesheet_2.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    {name: 'game_spritesheet_3', path: new URL('@static/images/game_spritesheet_3.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    {name: 'game_spritesheet_4', path: new URL('@static/images/game_spritesheet_4.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    {name: 'colonist_rush_background_gradient', path: ColonistRushBackgroundGradient, tags: [Tag.Universal]},

    // Not used in PixiJS but should be preloaded and cached for UIGame
    {name: 'PRELOAD_ONLY_dice_1', path: Dice1, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_2', path: Dice2, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_3', path: Dice3, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_4', path: Dice4, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_5', path: Dice5, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_6', path: Dice6, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_red_1', path: DiceRed1, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_red_2', path: DiceRed2, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_red_3', path: DiceRed3, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_red_4', path: DiceRed4, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_red_5', path: DiceRed5, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_red_6', path: DiceRed6, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_event_barbarian', path: DiceEventBarbarian, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_event_science', path: DiceEventScience, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_event_trade', path: DiceEventTrade, tags: [Tag.Universal]},
    {name: 'PRELOAD_ONLY_dice_event_politics', path: DiceEventPolitics, tags: [Tag.Universal]},

    // Uncomment if spritesheets are needed
    // {name: 'game_spritesheet_6', path: new URL('@static/images/game_spritesheet_6.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
    // {name: 'game_spritesheet_7', path: new URL('@static/images/game_spritesheet_7.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
    // {name: 'game_spritesheet_8', path: new URL('@static/images/game_spritesheet_8.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
    // {name: 'game_spritesheet_9', path: new URL('@static/images/game_spritesheet_9.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
]

export function getImagesToPreload(): ImageInterface[] {
    return allImages.filter((img: ImageInterface) => img.tags.includes(Tag.Universal))
}

export function getImageNameFromFileName(fileName: string): string | undefined {
    const searchString = `/${fileName}`
    const image = allImages.find((img: ImageInterface) => img.path.includes(searchString))
    return image?.name
}

export function getMerchantImageNameForPlayer(player: PlayerColor): string {
    switch(player) {
        case PlayerColor.None: return ''
        case PlayerColor.Red: return 'icon_merchant_red'
        case PlayerColor.Blue: return 'icon_merchant_blue'
        case PlayerColor.Orange: return 'icon_merchant_orange'
        case PlayerColor.Green: return 'icon_merchant_green'
        case PlayerColor.Black: return 'icon_merchant_black'
        case PlayerColor.Bronze: return 'icon_merchant_bronze'
        case PlayerColor.Silver: return 'icon_merchant_silver'
        case PlayerColor.Gold: return 'icon_merchant_gold'
        case PlayerColor.White: return 'icon_merchant_white'
        case PlayerColor.Purple: return 'icon_merchant_purple'
        case PlayerColor.MysticBlue: return 'icon_merchant_mysticblue'
        case PlayerColor.Pink: return 'icon_merchant_pink'
    }
}
